module.exports = __webpack_public_path__ + "media/luxury-2026/nash-garden-exterior-18654246.jpg";